"use strict";
exports.__esModule = true;
exports.UNIT_ENTRY = exports.UNIT_SELECTION = void 0;
exports.UNIT_SELECTION = {
    SEARCH_LABEL: 'Search units'
};
exports.UNIT_ENTRY = {
    HEADER: 'Which unit do you live in?',
    SUB_HEADER: 'If your home doesn’t have a unit number, leave this blank.',
    INPUT_LABEL: 'Apartment, suite, or unit #',
    CTA: 'Confirm'
};
